import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-prepare-skeleton-loader',
  templateUrl: './prepare-skeleton-loader.component.html',
  styleUrls: ['./prepare-skeleton-loader.component.scss']
})
export class PrepareSkeletonLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
